import { useEffect } from "react";
import { Constants } from "../utils/Constants";

const ChatWootWidget = ({ empresa }) => {
  useEffect(() => {
    const scriptId = "chatwoot-script";

    window.chatwootSettings = {
      hideMessageBubble: false,
      position: "right",
      locale: "pt_BR",
      type: "standard",
    };

    if (!document.getElementById(scriptId)) {
      (function(d, t) {
        var g = d.createElement(t),
          s = d.getElementsByTagName(t)[0];
        g.src = Constants.chatWootBaseUrl + "/packs/js/sdk.js";
        g.id = scriptId;
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: Constants.chatWootWebsiteToken,
            baseUrl: Constants.chatWootBaseUrl,
          });
        };
      })(document, "script");
    } else if (window.$chatwoot) {
      window.$chatwoot.toggleBubbleVisibility("show");
    }

    return () => {
      if (window.$chatwoot) {
        window.$chatwoot.reset();
        window.$chatwoot.toggleBubbleVisibility("hide");
      }
    };
  }, []);

  useEffect(() => {
    if (!window.$chatwoot) return;
    window.$chatwoot.setCustomAttributes({
      nome: empresa?.emp_nome_fantasia ?? "",
      cnpj: empresa?.emp_cnpj ?? "",
    });
    window.$chatwoot.toggleBubbleVisibility("show");
  }, [empresa?.emp_nome_fantasia, empresa?.emp_cnpj]);

  return null;
};

export default ChatWootWidget;
